import { takeLatest, put, call, all } from 'redux-saga/effects';
import { getAppListWithAccessDetails } from '@api/app';
import { fetchAppList, fetchAppListFailed, fetchAppListSucceed } from '@redux/ducks/app/app';

// Workers

export function* fetchAppListTask({ payload }) {
  try {
    const response = yield call(getAppListWithAccessDetails, payload);

    yield put(fetchAppListSucceed(response));
  } catch (error) {
    yield put(fetchAppListFailed(error));
  }
}

// Watchers

export function* watchFetchAppList() {
  yield takeLatest([fetchAppList], fetchAppListTask);
}

// Saga

export default function* appSaga() {
  yield all([watchFetchAppList()]);
}
